export const PROVIDER_JOB_RESPONSES_ROUTES = {
  get: '/hlx/job-responses/job-listing-responses',
};

export const JOB_RESPONSE_VIEWED_ROUTES = {
  post: '/job-responses/{responseId}/viewed',
};

export const JOB_NEGOTIATION_BY_RESPONSE_ROUTES = {
  get: '/job-listings/negotiations/by-response/{responseId}',
};
